import React, { Component } from 'react'
import axios from 'axios'
import QuestionsList from '../Quiz/QuestionsList'
import ResultsForm from '../ResultsForm'
import Success from '../Success'

export class Quiz extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEmailPopup: false,
            showSuccessPopup: false,
            step: 1,
            link: this.props.link,
            ageGroupID: undefined,
            responses: [],
            email: undefined,
            invalidEmail: false
        }
    }

    nextStep = () => {
        const { step } = this.state;
        this.setState({
            step: step + 1
        })
    }

    prevStep = () => {
        const { step } = this.state;
        this.setState({
            step: step - 1
        })
    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    toggleEmailPopup() {
        this.setState({
            showEmailPopup: !this.state.showEmailPopup
        })
    }

    handleChange = input => e => {
        this.setState({ [input]: e.target.value })
    }

    handleChangeForced = (input, e) => {
        this.setState({ [input]: e })
    }

    handlePayLoad = e => {
        const { responses } = this.state;
        let dontEnter = true;
        for (let i = 0; i < responses.length; i++) {
            if (e.category_id === responses[i].category_id) {
                responses[i] = e;
                dontEnter = false;
                break;
            }
        }
        if (dontEnter)
            responses.push(e);
    }



    POST_ACTION = () => {
        function ValidateEmail(email) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
                return (true)
            }
            return (false)
        }

        if (ValidateEmail(this.state.email)) {
            axios.post('http://web.wholechildapp.com/api/quizzes',
                {
                    email: this.state.email,
                    age_group_id: this.state.ageGroupID,
                    type: 'web',
                    responses: this.state.responses
                }).then(
                    this.setState({
                        showEmailPopup: false,
                        showSuccessPopup: true

                    })
                )
                .catch(function (error) {
                    console.log(error);
                });
        }
        else {
            this.setState({
                invalidEmail: true
            })
        }
    }
    render() {
        return (
            <div>
                <QuestionsList
                    api_link={this.state.link}
                    handleChangeForced={this.handleChangeForced}
                    handlePayLoad={this.handlePayLoad}
                    responses={this.state.responses}
                />
                {this.state.showEmailPopup ?
                    <ResultsForm
                        closeEmailPopup={this.toggleEmailPopup.bind(this)}
                        invalidEmail={this.state.invalidEmail}
                        handleChange={this.handleChange}
                        POST_ACTION={this.POST_ACTION}
                    />
                    : null
                }
                {this.state.showSuccessPopup ? <Success /> : null}
            </div>
        )
    }
}

export default Quiz
